// import cv from "./CV.pdf";
import resume from "../../CV/resume.pdf";
import {
  faGithub,
  faLinkedin,
  faTelegram,
  faGoogle,
  faReadme,
} from "@fortawesome/free-brands-svg-icons";
export const socialLinks = [
  { name: faLinkedin, link: "https://www.linkedin.com/in/jonathan-n-35068042b" },
  { name: faGithub, link: "https://github.com/smarttopdev" },
  { name: faTelegram, link: "https://t.me/incredible_success" },
  // {name: "Resume", link: cv},
  { name: faGoogle, link: "mailto:jonathan.nolendev@gmail.com" },
  { name: faReadme, link: resume },
];
